import { cloneElement, type CSSProperties, type ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';
import type { ExtendedColor } from '@witmetrics/unison-core';
import type { IconSize, Variant } from './types';
import { classes, styles } from './utils';

export type IconProps = {
  className?: string;
  style?: CSSProperties;
  size?: IconSize;
  variant?: Variant;
  color?: ExtendedColor;
  backgroundColor?: ExtendedColor;
  borderColor?: ExtendedColor | null;
  icon: ReactElement;
};

export default function Icon({
  className,
  style = {},
  size = 'base',
  variant = 'contained',
  color = 'grey-6',
  backgroundColor = 'grey-1',
  borderColor = 'grey-3',
  icon,
}: IconProps) {
  let wrapperSize = classes.wrapperBase;
  let iconSize = classes.iconBase;
  if (size === 'lg') {
    wrapperSize = classes.wrapperLarge;
    iconSize = classes.iconLarge;
  } else if (size === 'sm') {
    wrapperSize = classes.wrapperSmall;
    iconSize = classes.iconSmall;
  } else if (size === 'xs') {
    wrapperSize = classes.wrapperExtraSmall;
    iconSize = classes.iconExtraSmall;
  }

  return (
    <div
      style={{
        ...styles.wrapper(variant, { color, backgroundColor, borderColor }),
        ...style,
      }}
      className={twMerge(
        classes.wrapper,
        borderColor !== null && classes.border,
        wrapperSize,
        className
      )}>
      <div className={classes.gradientFilter} />
      {cloneElement(icon, {
        className: twMerge(classes.icon, iconSize, icon.props.className),
      })}
    </div>
  );
}
